import { MapPin, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./motion";
import { LOCALITIES } from "@/lib/localities";

const extraAreas = ["Banjara Hills", "Jubilee Hills", "Nizampet", "Bachupally", "LB Nagar", "Uppal", "Kompally"];

export default function AreasServed() {
  return (
    <section id="areas" className="py-24 md:py-36 bg-white border-t border-steel-200">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="font-label text-xs tracking-[0.3em] uppercase text-steel-500 mb-4">Coverage</p>
            <h2 className="font-display font-black tracking-tighter text-steel-900 text-4xl md:text-5xl leading-none mb-6">
              Installing across Hyderabad.
            </h2>
            <p className="text-steel-600 leading-relaxed">
              From IT-corridor high-rises to gated communities, our crews cover the whole city.
              Tap your locality for area-specific details, or call us — we probably serve it.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <div className="flex flex-wrap gap-3" data-testid="areas-list">
            {LOCALITIES.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.03}>
                <Link
                  to={`/areas/${a.slug}`}
                  data-testid={`area-link-${a.slug}`}
                  className="group inline-flex items-center gap-2 border border-steel-300 px-5 py-3 font-label text-sm text-steel-800 hover:bg-steel-800 hover:text-white hover:border-steel-800 transition-colors"
                >
                  <MapPin size={14} /> {a.name}
                  <ArrowUpRight size={14} className="opacity-0 -ml-1 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                </Link>
              </Reveal>
            ))}
            {extraAreas.map((a, i) => (
              <Reveal key={a} delay={(LOCALITIES.length + i) * 0.03}>
                <span className="inline-flex items-center gap-2 border border-steel-200 px-5 py-3 font-label text-sm text-steel-500">
                  <MapPin size={14} /> {a}
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
